<template>
  <s-alert
    title="This page hasn&rsquo;t been translated into English yet"
    description="But we&rsquo;re working on&nbsp;it."
    :is-visible="isVisible"
    @closeClick="close"
  ></s-alert>
</template>

<script>
export default {
  name: 'SAlertTranslation',
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    this.isVisible = this.$i18n.locale === 'en'
  },
  methods: {
    close() {
      this.isVisible = false
    }
  }
}
</script>
